/* Coffin Drawers premium motion layer (forked from the verified Frost Bit layer).
   - Scroll reveals: motion.css hides the targets under html.fx-motion (set inline in <head>, so nothing
     flashes); this script adds .is-in as each one scrolls into view. Siblings that enter together get a
     stagger (--fx-d: 0, 80, 160 ... ms), computed per batch so a block that enters later never waits for
     delays that belonged to siblings revealed earlier. Editorial blocks that scroll back out BELOW the
     viewport are re-armed, so scrolling up and down again pops them again; controls the shopper is
     comparing (buy box, gallery, FAQ) reveal once. Nothing is ever hidden while it is above the reader.
   - A control inside a still-hidden block that takes keyboard focus reveals its block at once.
   - Parallax on the large photos, hero depth (copy drifts and fades as the page leaves the hero), a
     scroll-progress line and a frosted header once the page scrolls, all on one rAF.
   - window.__fxMotion is set LAST: if anything here throws, the <head> switch removes fx-motion at 4 s
     (and the catch below removes it at once), so content can never stay hidden.
   Never runs in the theme editor or with prefers-reduced-motion (the <head> script leaves fx-motion off).
   FAMILIES must stay in sync with the reveal selectors in motion.css. */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('fx-motion')) { window.__fxMotion = true; return; }
  try {
    var NOT_CONTENT = ':not(style):not(script):not(noscript):not(link):not(template)';
    var FAMILIES = [
      /* rise */
      '.ps__text > :not(.ps__title):not(.ps__points)' + NOT_CONTENT,
      '.gc-wrap > .gc-eyebrow, .gc-wrap > .gc-lead',
      '.ug__head > :not(.ug__title)' + NOT_CONTENT,
      '.cc__head > :not(.cc__title)' + NOT_CONTENT,
      '.image-with-text__content > :not(.image-with-text__heading)' + NOT_CONTENT,
      '.gc-split__body > :not(h2):not(.gc-box-list)' + NOT_CONTENT,
      '.tm',
      '.footer-block, .footer__content-bottom',
      '.product__info-container > :is(.product__title, .gc-benefits, .review-avatars, .rating-stars, .review-items-container, .product__accordion, .product-notice, .payment-badges-block)',
      /* title */
      '.ps__title, .gc-wrap > h2, .ug__title, .cc__title, .faq__title, .image-with-text__heading, .gc-split__body > h2, .title-wrapper-with-link',
      /* pop */
      '.gc-cards > .gc-card, .cc__grid > .cc__card, .ug__grid > .ug__item',
      '.kaching-bundles__bars > .kaching-bundles__bar',
      '.thumbnail-list__item, .color-swatch',
      /* slide */
      '.ps__points > .ps__point, .faq > .faq__item, .gc-benefits > li, .gc-box-list > li',
      /* clip */
      '.ps__media, .image-with-text__media, .gc-split__media, .splide__slide__container'
    ];
    /* blocks that reveal once: the shopper is comparing inside them, so re-popping would be fatiguing */
    var ONCE = '.product__info-container, media-gallery, .thumbnail-list, .faq';
    var STEP = 80, MAX_STEPS = 7, RESET_GUARD = 1500;

    function byDom(a, b) { return a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1; }

    /* Every target, in DOM order, with the element whose visibility decides it: carousel slides sit off to
       the side and never intersect on their own, and clipped gallery thumbnails never intersect either, so
       they follow their container; everything else is its own key. */
    var targets = [];
    var seen = new Set();
    FAMILIES.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (seen.has(el)) return;
        seen.add(el);
        targets.push(el);
      });
    });
    targets.sort(byDom);
    var byKey = new Map();
    targets.forEach(function (el) {
      var key = el.closest('.splide, .thumbnail-list') || el;
      if (!byKey.has(key)) byKey.set(key, []);
      byKey.get(key).push(el);
    });

    var shownAt = new WeakMap();
    var landed = false;
    function now() { return (window.performance && performance.now) ? performance.now() : Date.now(); }

    /* Reveal a batch of elements with one stagger counter per parent (DOM order inside the batch). Elements
       that take no space (empty wrappers, hidden helpers) reveal at once without using a stagger slot; a FAQ
       title keeps its own slot so the first row starts at 0 ms. */
    function revealBatch(els) {
      var counters = new Map();
      els.forEach(function (el) {
        if (el.classList.contains('is-in')) return;
        shownAt.set(el, now());
        if (!el.getClientRects().length) { el.classList.add('is-in'); return; }
        var group = el.matches('.faq__title') ? el
                  : el.parentElement.classList.contains('splide__slide') ? el.closest('.splide')
                  : el.parentElement;
        var n = counters.get(group) || 0;
        counters.set(group, n + 1);
        el.style.setProperty('--fx-d', Math.min(n, MAX_STEPS) * STEP + 'ms');
        if (!landed && el.classList.contains('kaching-bundles__bar--selected')) { landed = true; el.classList.add('fx-landed'); }
        el.classList.add('is-in');
      });
    }
    function hide(els) {
      els.forEach(function (el) {
        if (!el.classList.contains('is-in') || el.closest(ONCE)) return;
        var wait = RESET_GUARD - (now() - (shownAt.get(el) || 0));
        if (wait > 0) {
          /* just landed: re-check once it has had its moment, and only if it is still below the fold */
          setTimeout(function () { if (el.getBoundingClientRect().top >= window.innerHeight) hide([el]); }, wait);
          return;
        }
        el.style.setProperty('--fx-d', '0ms');
        el.classList.remove('is-in');
      });
    }

    /* Safety net: anything already scrolled past (fast scroll, anchor jump, restored position, a scroll that
       stops with an element in the observer's bottom margin) shows at once. */
    function sweep() {
      var limit = window.innerHeight;
      var late = targets.filter(function (el) {
        return !el.classList.contains('is-in') && el.getBoundingClientRect().top < limit;
      });
      if (late.length) revealBatch(late);
    }

    if (!('IntersectionObserver' in window)) {
      revealBatch(targets);
    } else {
      var io = new IntersectionObserver(function (entries) {
        var showing = [];
        entries.forEach(function (e) {
          var els = byKey.get(e.target) || [];
          if (e.isIntersecting) {
            showing.push.apply(showing, els);
          } else {
            /* left through the bottom edge (the observer's root is the viewport minus its bottom margin):
               arm it to pop again on the way back down. Leaving through the top never hides anything. */
            var edge = e.rootBounds ? e.rootBounds.bottom : window.innerHeight;
            if (e.boundingClientRect.top >= edge - 1) hide(els);
          }
        });
        if (showing.length) { showing.sort(byDom); revealBatch(showing); }
      }, { rootMargin: '0px 0px -8% 0px', threshold: [0, 0.12] });
      byKey.forEach(function (_, key) { io.observe(key); });

      window.addEventListener('load', function () { setTimeout(sweep, 1200); });
      window.addEventListener('pageshow', sweep);
      var idle;
      window.addEventListener('scroll', function () { clearTimeout(idle); idle = setTimeout(sweep, 180); }, { passive: true });
      /* keyboard: a control inside a still-hidden block can take focus while the block sits in the margin */
      document.addEventListener('focusin', function (e) {
        var late = targets.filter(function (t) { return !t.classList.contains('is-in') && t.contains(e.target); });
        if (late.length) revealBatch(late);
      }, true);
    }

    /* Scroll progress line + frosted header + parallax + hero depth, all on one rAF. */
    var bar = document.createElement('div');
    bar.className = 'fx-progress';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    setTimeout(function () { root.classList.add('fx-settled'); }, 2500);   /* first-paint-only animations end */

    var para = [].slice.call(document.querySelectorAll('.hero__media img, .ps__media img, .image-with-text__media img'));
    var heroContent = document.querySelector('.hero .hero__content');
    var hero = heroContent ? heroContent.closest('.hero') : null;
    var ticking = false;
    function frame() {
      ticking = false;
      var y = window.scrollY || window.pageYOffset;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.transform = 'scaleX(' + (max > 0 ? Math.max(0, Math.min(1, y / max)) : 0) + ')';
      root.classList.toggle('fx-scrolled', y > 12);
      if (max - y < 4) sweep();     /* at the end nothing can scroll further into the margin */
      var vh = window.innerHeight;
      for (var i = 0; i < para.length; i++) {
        var r = para[i].parentElement.getBoundingClientRect();
        if (r.bottom < -100 || r.top > vh + 100) continue;
        /* -1 when the box enters at the bottom, +1 when it leaves at the top. The photos rest at scale 1.08
           (motion.css), which leaves ~4% of slack on each edge, so an 18-24px drift never shows a gap. */
        var t = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
        var amp = para[i].closest('.hero__media') ? -24 : 18;
        para[i].style.translate = '0 ' + (Math.max(-1, Math.min(1, t)) * amp).toFixed(1) + 'px';
      }
      if (hero) {
        var hr = hero.getBoundingClientRect();
        if (hr.bottom > 0) {
          var gone = Math.max(0, -hr.top);                       /* px of hero already scrolled away */
          var k = Math.min(1, gone / Math.max(1, hr.height * 0.7));
          heroContent.style.setProperty('--fx-hero-y', (gone * 0.28).toFixed(1) + 'px');
          heroContent.style.setProperty('--fx-hero-o', (1 - k * 0.9).toFixed(3));
        }
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    frame();
    window.__fxMotion = true;
  } catch (err) {
    root.classList.remove('fx-motion');
    if (window.console && console.warn) console.warn('motion layer off:', err);
  }
})();
